// extracted by mini-css-extract-plugin
export var addressFields = "_ma-0";
export var animationContainer = "_ma-1";
export var footer = "_ma-2";
export var lineItems = "_ma-3";
export var modalContent = "_ma-4";
export var orderName = "_ma-5";
export var strong = "_ma-6";
export var warning = "_ma-7";